import { apiService } from '@/lib/axios-config';

import { serviceOptions } from './codegen/serviceOptions';

serviceOptions.axios = apiService;
